const faqs = [
  {
    id: 1,
    heading: 'How is the window installation process?',
    content:
      'Learn about our window installation process, including what to expect and how our team ensures precise and efficient installations to enhance your home\'s aesthetics and energy efficiency.',
  },
  {
    id: 2,
    heading: 'What factors should I consider when replacing a door?',
    content:
      'Explore the important factors to consider when replacing a door, such as material options, style choices, security features, and energy efficiency considerations, to make an informed decision for your home.',
  },
  {
    id: 3,
    heading: 'How can I improve energy efficiency with new windows and doors?',
    content:
      'Discover how upgrading to energy-efficient windows and doors can reduce energy consumption, lower utility bills, and enhance indoor comfort by minimizing heat transfer and improving insulation.',
  },
  {
    id: 4,
    heading: 'What maintenance is required for windows and doors?',
    content:
      'Learn about the maintenance tasks recommended for windows and doors, including cleaning, lubrication, and inspection, to ensure their longevity, performance, and appearance over time.',
  },
  {
    id: 5,
    heading: 'What security features are available for windows and doors?',
    content:
      'Explore the various security features and options available for windows and doors, such as multi-point locking systems, impact-resistant glass, reinforced frames, and smart security technology, to enhance home security and peace of mind.',
  },
];

export default faqs;